export async function getInsurance(reg:string) {
    const reactAppData = window.react_data.api_url ? window.react_data : {api_url:'http://localhost:8000/api/v1/'};
    const endPoint = 'insurance';

    let data = new FormData();
    data.append('reg', reg);
    return await fetch(reactAppData.api_url+endPoint, {body:data, method:'post'})
        .then(res => res.json())
        .then(
            (result) => {
                   return result
            },
            (error) => {
                return {error:error}
            }
        );
}
